module.exports = __webpack_public_path__ + "img/bg_avatar_male_13.3387501a.png";